import { CustomerService } from "./CustomerService";

export type { ICustomerService, IUpdateCustomerEmailsParams } from "./ICustomerService";

export const customerService = new CustomerService();
